export { default } from './tag-3'
